import { useApiQuery } from '@portals-platform/api-client';
import { ENDPOINTS } from '../api/endpoints.js';
import type { CertificateResponse } from '../api/responses.js';
import { queryKeys } from '../query-keys.js';

export function useCertificate(id: string) {
  const {
    data: certificate,
    isLoading,
    isError,
    error,
  } = useApiQuery<CertificateResponse>([...queryKeys.certificate(id)], ENDPOINTS.certificate(id));

  return { certificate, isLoading, isError, error };
}
